var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "bloomDialog",
      attrs: {
        visible: _vm.visible,
        show: _vm.show,
        "show-close": false,
        "close-on-click-modal": _vm.closeOnClickModal,
        "append-to-body": "",
        width: _vm.width + "px",
        top: _vm.top
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        close: function($event) {
          return _vm.OnClose()
        }
      }
    },
    [
      _vm.hasCloseIcon
        ? _c(
            "div",
            {
              staticClass: "icon-room",
              on: {
                click: function($event) {
                  return _vm.$emit("update:show", false)
                }
              }
            },
            [_c("i", { staticClass: "blpc icon-size" }, [_vm._v("")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-995d0750", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-995d0750","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/bloom-dialog.vue
// module id = null
// module chunks = 